import styled from "styled-components";
import colors from "@streeteasy/design-system/deprecated/colors";
import Text from "@streeteasy/design-system/deprecated/Text";
import Dismissable from "@streeteasy/design-system/legacy/Dismissable";
import TimedDismissable from "@streeteasy/design-system/legacy/TimedDismissable";

const toastContainerStyles = `
  align-items: center;
  background-color: white;
  border: 1px solid ${colors.rabbitGrey};
  border-radius: 4px;
  box-shadow: 2px 8px 20px 0 rgba(0, 0, 0, 0.2),
    1px 1px 4px 0 rgba(0, 0, 0, 0.25), 0 2px 4px 0 rgba(0, 0, 0, 0.08);
  box-sizing: border-box;
  display: flex;
  margin: 0 auto;
  max-width: 696px;
  padding: 14px;
  width: 100%;

  button {
    height: 10px;
    width: 9px
  }
`;

const ToastWrapper = styled.div`
  box-sizing: border-box;
  left: 50%;
  max-width: 696px;
  padding: 0 10px;
  position: fixed;
  top: 65px;
  transform: translate(-50%, 0);
  width: 100%;
  z-index: 9999;
`;

const PersistentToastContainer = styled(Dismissable)`
  ${toastContainerStyles};
  ${props => props.optionalStyles};
`;

const ToastIcon = styled.i.attrs(props => ({
  className: `fa fa-${props.icon}`
}))`
  align-self: flex-start;
  color: ${colors.primary};
  font-size: 16px;
  margin-top: 2px;
  padding: 0;
`;

const TimedToastContainer = styled(TimedDismissable).attrs({
  time: 6000
})`
  ${toastContainerStyles};
  ${props => props.optionalStyles};
`;

const ToastText = styled(Text)`
  padding-left: 15px;
  padding-right: 40px;
`;

PersistentToastContainer.displayName = "PersistentToastContainer";
TimedToastContainer.diplayName = "TimedToastContainer";
ToastIcon.displayName = "ToastIcon";
ToastText.displayName = "ToastText";

export {
  PersistentToastContainer,
  TimedToastContainer,
  ToastIcon,
  ToastText,
  ToastWrapper
};
